import { headerStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailHeader";
import { userSetupSettingsStyles } from "@insite/content-library/Widgets/UserSetup/UserSetupSettings";
import { userSetupStatusStyles } from "@insite/content-library/Widgets/UserSetup/UserSetupStatus";
import { userSetupUserInformationStyles } from "@insite/content-library/Widgets/UserSetup/UserSetupUserInformation";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

headerStyles.shareEntityButtonStyles = {
    button: {
        variant: "secondary",
        css: css`
            border: 2px solid ${getColor("primary")};
            color: ${getColor("info")} !important;
        `,
    },
};

headerStyles.menuHiddenContainer = {
    above: "md",
        css: css`
            margin-right: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-right: 20px;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
};
// ---------------------------------------------------

userSetupStatusStyles.title = {
    variant: "h5",
    css: css`
        background-color: ${getColor("secondary")};
        padding: 10px;
        border-radius: 5px;
        margin-bottom: 10px;
    `,
};

// ---------------------------------------------------

userSetupUserInformationStyles.title = {
    variant: "h5",
    css: css`
        background-color: ${getColor("secondary")};
        padding: 10px;
        border-radius: 5px;
        margin-bottom: 10px;
    `,
};

// ---------------------------------------------------

userSetupSettingsStyles.title = {
    variant: "h5",
    css: css`
        background-color: ${getColor("secondary")};
        padding: 10px;
        border-radius: 5px;
        margin-bottom: 10px;
    `,
};

